export default "__VITE_ASSET__BGnRSA$Q__"